import { ajax, jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { underscore } from '@ember/string';
import { isArray } from '@ember/array';
import { isPresent } from '@ember/utils';
export const SERVICE_PREFIX = '/services/squareup.rolodex.RolodexService/';
export function makeRPC(url, requestClass, responseClass, options) {
  function req(params) {
    return jsonPost(url, requestClass.create(params), typeof options === 'function' ? options() : options).then(function (resp) {
      return responseClass.deserialize(resp);
    });
  }
  req.url = url;
  return req;
}

// makeRPCProxy is copied from the same function in app/clients/rpc-helpers.js.
// We'd ideally like to consolidate the two functions eventually.
export function makeRPCProxy(url, requestClass, responseClass, options) {
  return function (params) {
    const result = responseClass.create({
      isLoading: true,
      isLoaded: false
    });
    jsonPost(url, requestClass.create(params), typeof options === 'function' ? options() : options).then(data => result.load(data)).catch(({
      xhr
    }) => {
      if (xhr && xhr.statusText) {
        result.set('error', xhr.statusText);
      }
      result.set('error', 'Server Error');
    }).finally(function () {
      result.setProperties({
        isLoading: false,
        isLoaded: true
      });
    });
    return result;
  };
}
function prepareFormData(data, formData) {
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key) && isPresent(data[key])) {
      if (isArray(data[key])) {
        data[key].forEach(item => prepareFormData(item, formData));
      } else {
        formData.append(underscore(key), data[key]);
      }
    }
  }
}
export function makeMultipartHTTP(url, requestClass, responseClass) {
  function req(options) {
    const fd = new FormData();
    prepareFormData(requestClass.create(options).getAllProperties(), fd);
    return ajax(url, {
      type: 'POST',
      data: fd,
      processData: false,
      contentType: false,
      dataType: 'json',
      timeout: 60000
    }).then(function (resp) {
      return responseClass.deserialize(resp);
    });
  }
  req.url = url;
  return req;
}